export default {
  methods: {
    link: function(data, openMode) {
      let type = data.type, // 栏目的类型
        template = data.template, // 栏目的模版类型
        link = data.link, // 栏目的链接
        category = data.category, // 栏目的类型ID
        id = data.id, // 二级菜单需要的文章ID
        pid = data.parent_id,
        target = data.target,
        query = data.query,
        firstChildCategory = data.firstChildCategory
      // console.log({ pid, type, template, link, category, id }) // eslint-disable-line no-console
      // console.log(data) // eslint-disable-line no-console

      if (type === 'catalogue') {
        // 目录型
        if (!firstChildCategory && data.children && data.children.length) {
          let res = data.children.filter(item => item.visible === 1)
          if (res.length) {
            firstChildCategory = res[0].id
          }
        }
        if (category === 'tour') {
          firstChildCategory = ''
        }
        if (category === 'www' || !category) {
          category = ''
          firstChildCategory = ''
        }

        if ((target && target === '_blank') || openMode === 'windowOpen') {
          let routeUrl = this.$router.resolve({
            path: `/${category}/${firstChildCategory}`,
            query
          })
          window.open(routeUrl.href)
        } else {
          this.$router.push({
            path: `/${category}/${firstChildCategory}`,
            query
          })
        }
      } else if (type === 'link') {
        // 链接型
        if ((target && target === '_blank') || openMode === 'windowOpen') {
          if (link && link.slice(0, 4) !== 'http') {
            let routeUrl = this.$router.resolve({
              path: link,
              query
            })
            window.open(routeUrl.href)
          } else {
            window.open(link)
          }
        } else {
          if (link && link.slice(0, 4) === 'http') {
            window.location.href = link
          } else {
            this.$router.push({
              path: link,
              query
            })
          }
        }
      } else if (type === 'list' || type === 'video') {
        // 列表型
        category = category || id
        if (
          template === 'with-thumbnail' ||
          template === 'basic' ||
          type === 'video'
        ) {
          // 带缩略图 及 标准格式 的列表
          if ((target && target === '_blank') || openMode === 'windowOpen') {
            let routeUrl = this.$router.resolve({
              path: `/document/${category}`,
              query
            })
            window.open(routeUrl.href)
          } else {
            this.$router.push({
              path: `/document/${category}`,
              query
            })
          }
          // console.log('list-with-thumbnail') // eslint-disable-line no-console
        } else {
          // 文本格式 的列表
          if ((target && target === '_blank') || openMode === 'windowOpen') {
            let routeUrl = this.$router.resolve({
              path: `/${category}/list`,
              query
            })
            window.open(routeUrl.href)
          } else {
            this.$router.push({
              path: `/${category}/list`,
              query
            })
          }
        }
      } else if (type === 'page') {
        // 页面型
        // 游览须知、关于我们
        if ((target && target === '_blank') || openMode === 'windowOpen') {
          let routeUrl = this.$router.resolve({
            path: `/${pid}/${category}`,
            query
          })
          window.open(routeUrl.href)
        } else {
          this.$router.push({
            path: `/${pid}/${category}`,
            query
          })
        }
      } else {
        // 没有type 或 type=info 的跳转至详情
        // console.log(type + '---' + link) // eslint-disable-line no-console
        if ((target && target === '_blank') || openMode === 'windowOpen') {
          window.open(`/${category}/info?id=${id}`)
        } else {
          this.$router.push({
            path: `/${category}/info`,
            query: {
              id
            }
          })
        }
      }
    }
  }
}
